var render, staticRenderFns
import script from "./CCarousel.vue?vue&type=script&lang=ts"
export * from "./CCarousel.vue?vue&type=script&lang=ts"
import style0 from "./CCarousel.vue?vue&type=style&index=0&id=5976b4ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports